import { ConfigProductStoryRatings } from "../../types/config";

export const configProductStoryRatings: ConfigProductStoryRatings = {
  //"overall": "Overall",
  design: "Design",
  features: "Features",
  performance: "Performance",
  value: "Value",
  "user-friendliness": "User-Friendliness",
  addictiveness: "Addictiveness",
  graphics: "Graphics",
  playability: "Playability",
  sound: "Sound",
  mobility: "Mobility",
};
